import React, { Component } from 'react'
import { withRouter } from 'react-router-dom'
import { graphql, compose } from 'react-apollo'
import Summary from './Summary'
import SetTravelers from './Steps/SetTravelers'
import AddInfo from './Steps/AddInfo'
import Activities from './Steps/Activities'
import AdditionalServices from './Steps/AdditionalServices'
import ReviewPay from './Steps/ReviewPay'
import StepZilla from 'react-stepzilla'
import { translate } from 'react-i18next'
import CREATE_PLAN_QUERY from './../../../graphql/CreatePlanBySteps.graphql'
import USER_QUERY from './../../../graphql/User.graphql'
import USER_BY_ID_QUERY from './../../../graphql/UserByID.graphql'
import mainConfig from '../../../config'
import moment from 'moment'

class BookingSteps extends Component {
  constructor(props) {
    super(props)
    this.updateState = this.updateState.bind(this)
    this.state = {
      planTitle: 'Plan title goes here...',
      editPlanTitle: false,
      planLocations: [
        {
          country: 'Croatia'
        },
        {
          country: 'Italy'
        }
      ],
      travelers: [],
      categories: [],
      categoryNames: [],
      requiredServices: [],
      serviceNames: [],
      startDate: this.props.startDate,
      endDate: this.props.endDate,
      daysCount: 0,
      price: 0,
      currency: 'usd',
      servicesToBook: [],
    }
  }

  componentWillReceiveProps(nextProps) {
    this.user = nextProps.data.user
    this.setState({
      daysCount: nextProps.location.state.countOfTripDays,
      price: nextProps.location.state.plan.price,
      currency: nextProps.location.state.currency,
      startDate: nextProps.location.state.startDate,
      endDate: nextProps.location.state.endDate,
      numDays: moment(nextProps.location.state.endDate).diff(moment(nextProps.location.state.startDate), 'days'),
      planTitle: this.getPlanTitle(nextProps.location.state.plan)
    })
  }

  updateState(data) {
    this.setState(data)
  }

  getPlanTitle(plan) {
    const { t } = this.props
    let title =  t('trip_to') + (plan.location.city != '' ? plan.location.city + ', ' : '') + plan.location.country + t('trip_for_days') + this.state.numDays + ' ' + t('days')
    return title;
  }

  getServicesSum() {
    return this.serviceNames
    ? this.serviceNames
        .map(service => {
          return service.price
        })
        .reduce((prev, curr, index) => {
          return prev + curr
        }, 0)
    : 0

  }

  getAmountOfPeople() {
    return this.state.partySize ? this.state.partySize + 1 : this.state.travelers ? this.state.travelers.length + 1 : 1
  }

  getTotalAmount() {
    let amount =  this.state.price * this.state.daysCount * this.getAmountOfPeople() + this.getServicesSum()
    return amount
  }      

  getTotalAmountWithFee() {
    let amount = this.getTotalAmount() * (1 + mainConfig.guruServiceFee)
    return amount
  }      

  saveBookingSteps = (transaction) => {

    let travelersWithoutAge = this.state.travelers.map(traveler => {
      return {
        name: traveler.name,
        yearOfBirth: traveler.yearOfBirth
      }
    })

    this.setState(
      {
        requestedBudgetCurrency: 'USD',
        orderStatus: 'NewOrder',
        travelers: travelersWithoutAge,
        orderingUserId: this.user.id,
        tripGuruId: this.props.match.params.guruId,
        servicesToBook: this.state.serviceNames.map(item=>item.name),
      },
      () => {
        this.props.createCustomizedPlan({
          variables: this.state
        })
      }
    )
  }

  render() {
    const { data, t, tripGuruProfile } = this.props
    this.steps = [
      {
        name: 'Set Travelers',
        component: <SetTravelers data={data} currentState={this.state} updateState={this.updateState.bind(this)} />
      },
      { name: 'Add Info', component: <AddInfo currentState={this.state} updateState={this.updateState.bind(this)} /> },
      { name: 'Activities', component: <Activities currentState={this.state} updateState={this.updateState.bind(this)} /> },
      {
        name: 'Additional Services',
        component: <AdditionalServices currentState={this.state} updateState={this.updateState.bind(this)} />
      },
      {
        name: 'Review and Pay',
        component: (
          <ReviewPay currentState={this.state} updateState={this.updateState.bind(this)} saveBookingSteps={(transaction) => this.saveBookingSteps(transaction)} amountToPay={this.getTotalAmountWithFee()} />
        )
      }
    ]

    return (
      <div className="booking-steps" style={{ paddingBottom: 150 }}>
        <div className="container">
          <div className="row">
            <div className="col-lg-8 col-md-8 col-sm-8">
              <div className="header">
                <span>{this.state.planTitle}</span>
              </div>
              <div className="step-progress wizard">
                <StepZilla
                  steps={this.steps}
                  showSteps={true}
                  showNavigation={!!this.state.travelingType}
                  stepsNavigation={!!this.state.travelingType}
                  prevBtnOnLastStep={true}
                  dontValidate={false}
                  preventEnterSubmission={false}
                  startAtStep={0}
                  backButtonText={t('back')}
                  nextButtonText={t('next')}
                  nextTextOnFinalActionStep={t('next')}
                />
              </div>
            </div>
            <div className="col-lg-4 col-md-4 col-sm-4">
              <Summary
                summary={this.state}
                user={data.user}
                updateState={this.updateState.bind(this)}
                saveBookingSteps={() => this.saveBookingSteps()}
                tripGuru={tripGuruProfile}
                getAmountOfPeople={() => this.getAmountOfPeople()}
                getTotalAmount={() => this.getTotalAmount()}
                getServicesSum={() => this.getServicesSum()}
              />
            </div>
          </div>
        </div>
      </div>
    )
  }
}

const enhance = compose(
  translate('booking_steps'),
  graphql(CREATE_PLAN_QUERY, {
    name: 'createCustomizedPlan'
  }),
  graphql(USER_QUERY, {
    options: {
      fetchPolicy: 'network-only'
    }
  }),
  graphql(USER_BY_ID_QUERY, {
    name: 'tripGuruProfile',
    options: props => ({
      variables: {
        id: props.match.params.guruId
      }
    })
  }),
  withRouter
)

export default enhance(BookingSteps)



// WEBPACK FOOTER //
// src/components/Guru/BookingSteps/index.jsx